<template>
  <router-view />
</template>

<script>
export default {
  // Every route is kept out of search indexes by default. A page that should
  // rank overrides this with the same vmid, which is how vue-meta resolves a
  // child against its parent. Report and feedback URLs carry a report id, and
  // the feedback routes carry an id_token in the query string, so an indexed
  // URL is a leak on its own.
  metaInfo() {
    return {
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex, noarchive',
        },
      ],
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.fr-wrapper ul:not(.browser-default) {
  padding-left: 24px;
  list-style-type: unset;
}
.fr-wrapper ul:not(.browser-default) > li {
  list-style-type: unset;
}
.fr-checkbox [type='checkbox'] + span:not(.lever) {
  position: unset;
  padding-left: unset;
  cursor: unset;
  display: unset;
  height: unset;
  line-height: unset;
  font-size: unset;
  -webkit-user-select: unset;
  -moz-user-select: unset;
  -ms-user-select: unset;
  user-select: unset;
}
.fr-checkbox [type='checkbox']:not(:checked),
.fr-checkbox [type='checkbox']:checked {
  position: unset;
  opacity: unset;
  pointer-events: unset;
}
.fr-checkbox [type='checkbox'] + span:not(.lever):before,
.fr-checkbox[type='checkbox']:not(.filled-in) + span:not(.lever):after {
  content: unset;
  position: unset;
  top: unset;
  left: unset;
  width: unset;
  height: unset;
  z-index: unset;
  border: unset;
  border-radius: unset;
  margin-top: unset;
  -webkit-transition: unset;
  transition: unset;
}
.fr-checkbox [type='checkbox']:not(.filled-in) + span:not(.lever):after {
  border: unset;
  transform: unset;
}
.fr-checkbox [type='checkbox'] + span:not(.lever):before,
.fr-checkbox [type='checkbox']:not(.filled-in) + span:not(.lever):after {
  content: unset;
  position: unset;
  top: unset;
  left: unset;
  width: unset;
  height: unset;
  z-index: unset;
  border: unset;
  border-radius: unset;
  margin-top: unset;
  -webkit-transition: unset;
  transition: unset;
}
.fr-popup .fr-checkbox input:checked + span {
  border: transparent 2px;
}
.fr-popup .fr-checkbox input:not(:checked) + span {
  border: transparent 2px;
}
</style>
